import { h } from '../pragma.mjs';
import { settings } from '../../config/settingsFactory.mjs';
import { getValidSetting } from '../../utils/common.mjs';

export default (isPublic) => {

    return (
        <div>

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikZapisy" href="#">Zápisy</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="postavilJsemStavbu" href="">Změna údajů o stavbách</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Stavba na cizím pozemku</strong></li>
                </ul>
            </gov-breadcrumbs>
            
            <gov-tiles role="list">
                <gov-tile role="listitem" id="rozcestnikPostavil3tile" href={isPublic ? getValidSetting(settings.urls?.NV?.public, '#', 'NV link public') : getValidSetting(settings.urls?.NV?.private, '#', 'NV link private')} target="_blank"> {/* id="rozcestnikPostavil3S8419" href="#" */}
                    <p>Zápis nové stavby, která je postavena na cizím pozemku</p>
                    <h3 slot="title">Zápis nové stavby&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="property" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" id="rozcestnikPostavil3S8414" href="#">
                    <p>Změna stavby, která je postavena na cizím pozemku</p>
                    <h3 slot="title">Změna stávající stavby</h3>
                    <gov-icon type="complex" name="property" slot="icon"></gov-icon>
                </gov-tile>             
            </gov-tiles>
        </div>
    )

}